import styled from 'styled-components';
import media from '../../../styles/media';

export const BigDifference = styled.p`
  background-color: ${props => props.theme[props.color]};
  padding: 15px;
  color: black;
`;

export const SliderTicks = styled.div`
  .slider-tick-line {
    display: inline;

    ${media.md`
    display: flex;
  `};
  }

  .slider-tick-line-title {
    box-sizing: border-box;
    flex-grow: 1;
    width: 100%;
    flex-basis: 40%;
    flex-shrink: 0;
    padding-right: 5px;
    color: ${props => props.theme.partgreen};

    ${media.md`
    width: 40%;
    flex-basis: 40%;
  `};
  }

  .slider-tick-line-value {
    box-sizing: border-box;
    flex-grow: 1;
    width: 100%;
    color: ${props => props.theme.partgreen};
  }
`;

export const SliderContent = styled.div`
  margin-top: 25px;

  h3 {
    margin-bottom: 15px;
    color: ${props => props.theme.color};
  }
`;

export default SliderTicks;
